import React, { useEffect } from "react";
import CardBerita from "../CardBerita";
import { getContent } from "../../../services";

const BeritaTerbaru = ({ isId, beritaTerbaruId, beritaTerbaruEn }: any) => {
  const [beritaState, setBeritaState] = React.useState<any>([]);

  const fetchBerita = async () => {
    try {
      const res = await getContent(4, 10, 1);
      setBeritaState(res.data.rows);
    } catch (err: any) {
      console.error(err.message);
    }
  };

  useEffect(() => {
    fetchBerita();
  }, []);

  return (
    <>
      {beritaState.map((r: any) => (
        <div style={{ marginTop: 30 }} key={r.title_id}>
          <CardBerita
            key={r.title}
            url={"/pusat-media/berita/" + r.title_id}
            data={r}
          />
        </div>
      ))}
    </>
  );
};

export default BeritaTerbaru;
